import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../showcase/Home';
import Window from '../os/Window';
import Experience from '../showcase/Experience';
import Projects from '../showcase/Projects';
import Contact from '../showcase/Contact';
import TopNavbar from '../showcase/TopNavbar';
import useInitialWindowSize from '../../hooks/useInitialWindowSize';
import { LanguageProvider } from '../../context/LanguageContext';

export interface ShowcaseExplorerProps extends WindowAppProps {}

const ShowcaseExplorer: React.FC<ShowcaseExplorerProps> = (props) => {
    const { initWidth, initHeight } = useInitialWindowSize({ margin: 100 });

    return (
        <Window
            top={24}
            left={56}
            width={initWidth}
            height={initHeight}
            windowTitle="Jose Eduardo - Portafolio"
            windowBarIcon="chrome"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
            bottomLeftText={'© Jose Eduardo Rendón Valencia - Software Engineer'}
        >
            <LanguageProvider>
                <div className="site-page">
                    <TopNavbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<Home />} />
                        <Route path="/experience" element={<Experience />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                </div>
            </LanguageProvider>
        </Window>
    );
};

export default ShowcaseExplorer;
